import { Editor, Element, NodeEntry } from "slate";

import ElementType from "../../../type/slate/ElementType";

const findMatchedElementTypes = (editor: Editor, type?: ElementType): [boolean, NodeEntry[]] => {
  const { selection } = editor;
  if (!selection || !type) {
    return [false, []];
  }

  const elements = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: (node) => !Editor.isEditor(node) && Element.isElement(node) && node.type === type,
    })
  );
  return [!!elements[0], elements];
};

export default findMatchedElementTypes;
